import { TagInput as IOTagInput } from '@descomplica/foundation-ui-components';
import React from 'react';

type Item = {
  guid: string;
  name: string;
};

type Props = {
  label: string;
  name: string;
  defaultValue?: Item[];
  values?: Item[];
  isMulti?: boolean;
  options: Item[];
  onChange: (value: string) => void;
};

export const TagInput: React.FC<Props> = (props) => {
  return (
    <IOTagInput
      label={props.label}
      placeholder={props.label}
      defaultValue={props.values}
      values={props.values}
      isMulti={props.isMulti}
      onChange={(value) => {
        props.onChange(value);
      }}
      availableTags={props.options}
    />
  );
};
